/* ONENULL v2 — finish swatches: swap image, select variant, keep the cart honest. */
(function () {
  function root(el, sel) { return el.closest(sel); }

  function apply(input) {
    var scope = root(input, '[data-swatch-scope]');
    if (!scope) return;
    var d = input.dataset;

    var img = scope.querySelector('[data-swatch-image], .product-card__frame img, .product-page__frame img');
    if (img && d.image) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = d.image;
      if (d.title) img.alt = (img.dataset.baseAlt || img.alt).replace(/ in .*$/, '') + ' in ' + d.title;
    }

    var idInput = scope.querySelector('[data-variant-input]');
    if (idInput) idInput.value = d.variantId;

    var price = scope.querySelector('[data-swatch-price]');
    if (price && d.price) price.textContent = d.price;

    var name = scope.querySelector('[data-swatch-name]');
    if (name && d.title) name.textContent = d.title;

    var add = scope.querySelector('[data-swatch-add]');
    var sold = scope.querySelector('[data-swatch-sold]');
    var available = d.available === 'true';
    if (add) {
      add.disabled = !available;
      if (add.dataset.labelAdd) {
        add.textContent = available ? add.dataset.labelAdd : (add.dataset.labelSold || 'Sold out');
      } else {
        add.hidden = !available;
      }
    }
    if (sold) sold.hidden = available;

    if (scope.dataset.swatchScope === 'product' && d.url) {
      try { history.replaceState({}, '', d.url); } catch (e) {}
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('[data-swatch]')) apply(input);
  });

  // Preselect the first available finish when the default one is sold out,
  // and sync each scope to whatever is checked on load.
  document.querySelectorAll('[data-swatch-scope]').forEach(function (scope) {
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('[data-swatch]'));
    if (!inputs.length) return;
    var checked = inputs.filter(function (i) { return i.checked; })[0];
    if (!checked || checked.dataset.available !== 'true') {
      var next = inputs.filter(function (i) { return i.dataset.available === 'true'; })[0];
      if (next) { next.checked = true; checked = next; }
    }
    if (checked) apply(checked);
  });
})();
